import { API_ENDPOINTS } from '@utils/endpoints';
import { BaseService } from '../baseService';

// Models
import { TransactionDetails, TransationInfoPayload } from '@models/Transaction';
import { APIResponse } from '../types';

export class TransactionService {
  /**
   * @function fetchTransactionInfo
   * @payload
   * @returns TransactionDetails
   */
  static fetchTransactionInfo = async (
    payload: TransationInfoPayload
  ): Promise<APIResponse<TransactionDetails>> => {
    const response = await BaseService.post(API_ENDPOINTS.TRANSACTION_INFO, payload);
    return response as APIResponse<TransactionDetails>;
  };
}
